export default {
  namespaced: true,
  state: {
    kpi: ['kpi1', 'kpi']
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  }
}
